<template>
  <div class="page-header">
    <el-card shadow="never">
      <div class="page-header-content">
        <div class="page-header-title">{{ pageTitle }}</div>
        <el-button size="small" style="float: right"> {{ buttonName }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    pageTitle: String,
    buttonName: String
  }
}
</script>
<style lang="scss" scoped>
.page-header {
  margin-bottom: 1rem;
  &-content {
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
   &-title{
    margin-left: 20px;
  }
}
</style>
